import { FormattedMessage } from 'react-intl';

import type {
  PurchaseWebTextValues,
  XingId,
} from '@xing-com/crate-common-graphql-types';
import type { RefinedPremiumContacts } from '@xing-com/crate-upsell-types';
import { useViewerData } from '@xing-com/hub';
import { Headline, Hero } from '@xing-com/typography';

import { ProfileContactsWithProduct } from './profile-contacts-with-product';

export type SalutationProps = {
  premiumContacts?: RefinedPremiumContacts;
  showFacepile: boolean;
} & Pick<PurchaseWebTextValues, 'heading'>;

const userFallback: Partial<XingId> = {};

export const Salutation: React.FC<SalutationProps> = ({
  heading,
  premiumContacts,
  showFacepile,
}) => {
  const user = useViewerData()?.data?.user || userFallback;
  const { firstName } = user;

  return (
    <div>
      <Hero size="small" sizeWide="medium">
        <FormattedMessage
          id="UPSELL_PURCHASE_CAMPAIGN_INTRO_HEADLINE"
          defaultMessage="Hello {firstName}!"
          values={{ firstName }}
        />
      </Hero>

      {showFacepile && premiumContacts ? (
        <ProfileContactsWithProduct
          renderLocation="salutation"
          isLargerSize
          premiumContacts={premiumContacts}
        />
      ) : (
        <Headline noMargin size="xxlarge" sizeWide="xxxlarge">
          {heading}
        </Headline>
      )}
    </div>
  );
};
